<template>
  <div>
    <div v-if="isShowPanel == 0">
      <div class="white-background list-top-margin">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>生产管理</el-breadcrumb-item>
          <el-breadcrumb-item><span style="color:#000;font-weight:bold;">销售订单</span></el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <list-top :form="formInline" @search="search" class="list-top-margin" :goodsShow="true"></list-top>
      </div>
      <div class="white-background goodBg">
          <el-row class="tbl-btn">
            <el-col :span="12" class="tbl-btn-left">
              <el-button size="small" type="primary" icon="el-icon-plus" @click="createSaleOrder">创建销售订单</el-button>
              <el-button size="small" type="primary" plain icon="el-icon-download" @click="templateDownload">模板下载</el-button>
              <el-button size="small" type="success" plain icon="el-icon-upload2" @click="importData">导入</el-button>
              <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportDataNew">导出</el-button>

               <el-upload  ref="goodsImp" name="upload" :action="action()" :on-change="
                  (file, fileList) => {
                  handleChange(file, fileList);
                  }
              "
                :auto-upload="false" :show-file-list="false" accept=".xlsx" v-show="false">

              </el-upload>
              <!-- <el-button type="text" :disabled="!isBatchPrint">批量打印</el-button>
              <el-button type="text" icon="el-icon-edit-outline">编辑打印模板</el-button> -->
            </el-col>
            <!-- <el-col :span="12" class="tbl-btn-right">
              <el-button type="primary" size="small" icon="el-icon-setting">移动端卡片配置</el-button>
              <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
            </el-col> -->
          </el-row>
          <!--列表-->
          <el-table
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          element-loading-text="加载中"
          :header-cell-style="_headerStyle"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
          ref="goodTable"
          :max-height="tableHeight"
          v-if="tableShow"

          >
            <el-table-column align="left" type="selection" :reserve-selection="true" width="60">
            </el-table-column>
            <el-table-column  type="expand">
              <template slot-scope="props">
                <el-table
                  size="small"
                  :data="props.row.productList"
                  highlight-current-row
                  stripe
                  :header-cell-style="_headerStyle"
                  style="width: calc(100% - 50px);margin-left:50px;"
                  max-height="250px"
                  >
                  <el-table-column label="产品编号" width="150">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.productCode" placement="top">
                        <span class="txt-overflow">{{scope.row.productCode}}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column label="产品名称" width="150">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.productName" placement="top">
                        <span class="txt-overflow">{{scope.row.productName}}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="specs" label="产品规格" ></el-table-column>
                  <!-- <el-table-column prop="technologyId" label="工艺路线" width="100"></el-table-column> -->
                  <el-table-column prop="unit" label="单位" ></el-table-column>
                  <!-- <el-table-column prop="stockNum" label="库存数量" width="100"></el-table-column>
                  <el-table-column prop="maxStock" label="最大库存" width="100"></el-table-column>
                  <el-table-column prop="minStock" label="最小库存" width="100"></el-table-column>
                  <el-table-column prop="safeStock" label="安全库存" width="100"></el-table-column> -->
                  <el-table-column prop="source" label="产品属性" ></el-table-column>
                  <el-table-column   prop="planNum" label="计划数" ></el-table-column>
                  <el-table-column   prop="goodNum" label="完成数" ></el-table-column>
                  <el-table-column    label="计划时间" width="220">
                    <template slot-scope="scope">
                      <span >{{scope.row.planStartTime +"~" + scope.row.planEndTime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName"></el-table-column>

                  <!--<el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>-->
                  <!-- <el-table-column prop="deptNo" label="创建人" width="100"></el-table-column> -->
                  <!--<el-table-column prop="updateTime" label="最后更新时间" width="140"></el-table-column>-->

                </el-table>

              </template>
            </el-table-column>
            <el-table-column align="left" type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column sortable  label="销售订单编号"  >
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.salesOrderCode" placement="top">
                  <span class="txt-overflow" >{{scope.row.salesOrderCode}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column  label="合同编号" >
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.contractCode" placement="top">
                  <span class="txt-overflow">{{scope.row.contractCode}}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column  label="客户名称">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.customerName" placement="top">
                  <span class="txt-overflow">{{scope.row.customerName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column  label="创建人" prop="creater"  width="150">

            </el-table-column>
            <el-table-column  label="创建时间" prop="createTime"  width="150">

            </el-table-column>
            <!-- <el-table-column  prop="deptNo" label="工单数" width="60">
            </el-table-column> -->
            <!-- <el-table-column  prop="deptNo" label="已结束工单" width="90">
            </el-table-column> -->
            <!-- <el-table-column  prop="deptNo" label="计划数" width="60">
            </el-table-column>
            <el-table-column  prop="deptNo" label="完工数" width="60">
            </el-table-column>
            <el-table-column  prop="deptNo" label="生产进度(%)" width="100">
            </el-table-column> -->

            <!-- <el-table-column   prop="deptNo" label="单据进度(%)" width="100">
            </el-table-column>
            <el-table-column  sortable prop="deptNo" label="创建时间" width="120">
            </el-table-column>
            <el-table-column  sortable prop="deptNo" label="更新时间" width="120">
            </el-table-column>
            <el-table-column  prop="creater" label="创建人" width="80">
            </el-table-column>
            <el-table-column   prop="updater" label="更新人" width="80">
            </el-table-column> -->

            <el-table-column align="left"  label="操作" width="100" >
              <template slot-scope="scope">
                <el-tooltip content="编辑">
                  <el-button type="primary" size="mini" icon="el-icon-edit" circle  @click="handleEdit(scope.$index, scope.row)"></el-button>

                </el-tooltip>
                <!-- <el-tooltip content="打印">
                  <el-button type="primary" size="mini" icon="el-icon-printer" circle @click="handleEdit(scope.$index, scope.row)"></el-button>

                </el-tooltip>
                <el-tooltip content="复制">
                  <el-button type="primary" size="mini" icon="el-icon-document-copy" circle @click="handleEdit(scope.$index, scope.row)"></el-button>

                </el-tooltip> -->
                <el-tooltip content="删除">
                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteSaleOrder(scope.$index, scope.row)"></el-button>

                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
    </div>
    <CreateGoods v-if="isShowPanel == 1" @goBack="goBack" @done="done" :mode="mode" :editRow="editRow"></CreateGoods>
  </div>
</template>

<script>
import CreateGoods from '@/views/goods/newGoods';
import { deptList, deptSave, deptDelete } from '@/api/userMG';
import Pagination from '@/components/Pagination';
import ListTop from '@/views/assemblyWorkOrder/list-top.vue';
import { querySalesOrderList,addUptSalesOrder,batchDelSalesOrder,queryAllSalesOrder,delSalesOrder,queryAllCustomSet,goodsBatchImp} from '@/api/business';
import {exportDataToExcel} from '@/utils/util';

export default {
  watch:{
    tblSelectionList(newList,oldList){
      this.isBatchPrint = (newList && newList != null && newList.length > 0);

    }
  },
  data() {
    return {

      isShowPanel:0,
      isBatchPrint:false,
      isSearchPanelShow:false,
      tblSelectionList:[],

      //--------------------------
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        // page: 1,
        // limit: 10,
        factoryId:"",
        // varLable: '',
        // varName: '',
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      userData:{},
      setList:[],
      sourceList:[{
        label:'自制',
        value:'0'
      },{
        label:'外购',
        value:'1'
      },{
        label:'委外',
        value:'2'
      }],
      editRow:{},
      mode:"create",
      tableHeight: 0,
      tableShow:false,
    }
  },
  // 注册组件
  components: {
    Pagination,
    CreateGoods,
    ListTop
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData);
      this.formInline.factoryId = this.userData.factoryId;
      this.init();
    }
  },
  mounted(){
    this.tableHeight = window.innerHeight - 400;
    this.tableShow = true
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    exportDataNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportData();
        return;
      }
      const header = [
        "销售订单编号",
        '合同编号',
        '客户名称',
        '产品编号',
        '产品名称',
        '产品规格',
        '单位',
        '产品属性',
        '计划数',
        '计划开始时间',
        '计划结束时间',
        '完成数',
        '创建人',
        '创建时间',


      ];
      const filterVal = [
        'salesOrderCode',
        'contractCode',
        'customerName',

        'productCode',
        'productName',
        'specs',
        'unit',
        'source',
        'planNum',

        'planStartTime',
        'planEndTime',
        'goodNum',
        'creater',
        'createTime',



      ];
      for(let k = 0;k<this.setList.length;k++){
        header.push(this.setList[k]['fieldName']);
        filterVal.push(this.setList[k]['fieldName']);
      }
      let selectData =  [];
      for(let j = 0;j < this.tblSelectionList.length;j++){
        let p = this.tblSelectionList[j];
        if(p.productList && p.productList.length > 0){
          for(let i = 0;i < p.productList.length;i++){
            let temp = {
              'salesOrderCode':p.salesOrderCode,
              'contractCode':p.contractCode,
              'customerName':p.customerName,
              'creater':p.creater,
              'createTime':p.createTime,

              'productCode':p.productList[i].productCode,
              'productName':p.productList[i].productName,
              'specs':p.productList[i].specs,
              'unit':p.productList[i].unit,
              'source':p.productList[i].source,
              'planNum':p.productList[i].planNum,
              'goodNum':p.productList[i].goodNum,

              'planStartTime':p.productList[i].planStartTime,
              'planEndTime':p.productList[i].planEndTime,
            }
            for(let k = 0;k<this.setList.length;k++){
              temp[this.setList[k]['fieldName']] = p.productList[i][this.setList[k]['fieldName']];
            }
            selectData.push(temp);
          }
        }else{
          let temp = {
            'salesOrderCode':p.salesOrderCode,
            'contractCode':p.contractCode,
            'customerName':p.customerName,
            'creater':p.creater,
            'createTime':p.creater,

            'productCode':'',
            'productName':'',
            'specs':'',
            'unit':'',
            'source':'',
            'planNum':'',
            'goodNum':'',

            'planStartTime':'',
            'planEndTime':'',
          }
          for(let k = 0;k<this.setList.length;k++){
              temp[this.setList[k]['fieldName']] = '';
          }
          selectData.push(temp)
        }

      }
      let filterData =JSON.parse(JSON.stringify(selectData));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"销售订单清册" + Date.now());
    },
    exportData(){

      var params = {
        condition: this.formInline,
        tableName:'销售订单',
        collection:'salesOrder',
      }
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "销售订单清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

      // exportExcel(params).then(res=>{

      // })
    },
    handleChange(file, fileList){
        let data = new FormData();

        data.append("file", file.raw);
        data.append("factoryId ", this.userData.factoryId);
        data.append("creater",this.userData.name + "(" + this.userData.account + ")");
        goodsBatchImp(data).then(res=>{
            this.search();
            this.$message({
                type: 'success',
                message: '上传成功',
            });
        });

    },
    action(){
      return this.$devEnv.API_ROOT + `/salesOrder/importData`;
    },
    templateDownload(){
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/salesOrder/downloadTemplate';
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "销售订单导入模板.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send();
    },
    importData(){
      this.$refs["goodsImp"].$refs['upload-inner'].handleClick();
    },
    init(){
        queryAllCustomSet(this.userData.factoryId,'product').then(res=>{
          this.setList = [];
          if(res['code'] == 200){
            this.setList = res['data'];
            this.getdata();
          }
        })
      },
    // 获取公司列表
    getdata() {
      this.loading = true
      var params = {
        condition: {},
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      };
      for(var key in this.formInline){

        if(this.formInline[key] && this.formInline[key] != null && (this.formInline[key].length > 0 || this.formInline[key].toString() != '')){
         if(key == "createTime" || key == "updateTime"){
            if(key == "createTime"){
              if(this.formInline.createCondition == "between" && this.formInline.createTime.length == 2){
                  params['condition'][key] = {
                      begin:this.formInline.createTime[0],
                      end:this.formInline.createTime[1],
                      type:this.formInline.createCondition,
                      data:'time'
                    }
                }else{
                  params['condition'][key] = {
                    type:this.formInline.createCondition,
                    value:this.formInline.createTime,
                    data:'time'
                  }
                }
            }else if(key == "updateTime"){
              if(this.formInline.updateCondition == "between" && this.formInline.updateTime.length == 2){
                  params['condition'][key] = {
                      begin:this.formInline.updateTime[0],
                      end:this.formInline.updateTime[1],
                      type:this.formInline.updateCondition,
                      data:'time'
                    }
                }else{
                  params['condition'][key] = {
                    type:this.formInline.updateCondition,
                    value:this.formInline.updateTime,
                    data:'time'
                  }
                }
            }
          }else if(key != "updateCondition" && key != "createCondition"){

            params['condition'][key] = this.formInline[key];
          }
        }
        }
      querySalesOrderList(params).then(res=>{
        this.loading = false;
        if(res.code == 200){
          this.listData = res.data.list;
          this.pageparm.total = res.data.total;
        }
      }).catch(()=>{
        this.loading = false;
      })

    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.pageparm.currentPage = 1;
      this.pageparm.pageSize = 10;
      this.getdata()
    },
    productFormat(val){
      var res = this.sourceList.filter(function(item){
        return item.value == val.source
      })
      if(res && res.length!=0){
        return res[0].label
      }
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editRow = row;
      this.mode = 'update';
      this.isShowPanel = 1;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata()
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    deleteSaleOrder(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delSalesOrder(row)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.getdata();
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },


    //-------------------
    /**
     * 控制查询面板显示隐藏
     */
    expandClick(){
      this.isSearchPanelShow = !this.isSearchPanelShow;
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val){
      this.tblSelectionList = val;
    },
    createSaleOrder(){
      this.editRow = {};
      this.mode = 'create';
      this.isShowPanel = 1;
    },
    goBack(){
      this.isShowPanel = 0;
    },
    done(options){
      this.isShowPanel = 0;
      if(options && options.type == 'save'){
        this.getdata()
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.el-divider__text{
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.el-divider--horizontal{
  margin: 10px 0px;
}
.date-picker{
  width: 100% !important;

}
.el-input__inner{
  height: 32px;
  line-height: 32px;
  padding: 0px 10px;
}
.el-form-item{
  margin-bottom: 10px;
}
.tbl-btn{
  width: 100%;
  height: 50px;
  line-height: 50px;

}
.tbl-btn .tbl-btn-right{
  text-align: right;
}
.tbl-pagination{
  text-align: right;
}
.txt-overflow{
  text-overflow:ellipsis;
  white-space:nowrap;
}
.goodBg{
  height: calc(100vh - 320px);
}
</style>





// WEBPACK FOOTER //
// src/views/goods/Goods.vue